var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import { keyMap } from "./utils/generic";

export var ConfirmationModal = function (_React$Component) {
	_inherits(ConfirmationModal, _React$Component);

	function ConfirmationModal(props) {
		_classCallCheck(this, ConfirmationModal);

		var _this = _possibleConstructorReturn(this, (ConfirmationModal.__proto__ || Object.getPrototypeOf(ConfirmationModal)).call(this, props));

		_initialiseProps.call(_this);

		if (props.show) {
			_this.init(props);
		}
		_this.state = { status: {}, body: _this.body };
		return _this;
	}

	_createClass(ConfirmationModal, [{
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.keyEvent && nextProps.keyEvent !== this.props.keyEvent && !(nextProps.show && !this.props.show)) {
				var keyCode = nextProps.keyEvent.which || nextProps.keyEvent.keyCode;
				var key = keyMap[keyCode];
				if (key === "Escape") {
					nextProps.keyEvent.preventDefault();
					this.onConfirm(false, false, nextProps);
				} else if (key === "Enter") {
					nextProps.keyEvent.preventDefault();
					this.onConfirm(true, true, nextProps);
				}
			}
			if (nextProps.show) {
				this.init(nextProps);
				this.setState({ body: this.body });
			}
		}
	}, {
		key: "render",
		value: function render() {
			// Render nothing if the "show" prop is false
			if (!this.props.show) {
				return null;
			}
			return React.createElement(
				"div",
				{
					className: "backdrop zebulon-modal-backdrop",
					style: { zIndex: 4 }
				},
				React.createElement(
					"div",
					{
						className: "modal zebulon-modal-confirmation",
						style: { display: "flex", top: 100, zIndex: 4 }
					},
					this.state.body,
					React.createElement(
						"div",
						{ className: "footer", style: { display: "flex" } },
						this.buttons
					)
				)
			);
		}
	}]);

	return ConfirmationModal;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.init = function (props, refresh) {
		var _props$detail = props.detail,
		    body = _props$detail.body,
		    type = _props$detail.type,
		    noRefresh = _props$detail.noRefresh;
		// do you wnat to save before

		if (type === "YesNoCancel") {
			_this2.buttons = [React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, true, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Yes"
			), React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, false, props);
						}
					},
					tabIndex: 1,
					key: 1
				},
				"No"
			), React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, false, props);
						}
					},
					tabIndex: 2,
					key: 2
				},
				"Cancel"
			)];
			// do you want to continue
		} else if (type === "YesNo") {
			_this2.buttons = [React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Yes"
			), React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 0,
					key: 1,
					autoFocus: true
				},
				"No"
			)];
			// foreign key selection
		} else if (type === "foreignKey" || type === "OkCancel" || type === "conflict") {
			_this2.buttons = [React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Ok"
			), React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 1,
					key: 1
				},
				"Cancel"
			)];
			if (!noRefresh && type === "foreignKey") {
				_this2.buttons.push(React.createElement(
					"button",
					{
						style: { minWidth: 70, margin: 5 },
						onClick: function onClick(e) {
							if (!e.defaultPrevented) {
								_this2.init(props, true);
								_this2.setState({
									status: { loading: true },
									body: _this2.body
								});
							}
						},
						tabIndex: 2,
						key: 2
					},
					"Refresh"
				));
			}
			// blocking alert
		} else if (type === "Ok") {
			_this2.buttons = [React.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Ok"
			)];
		}
		_this2.body = React.createElement(
			"div",
			null,
			body
		);
		if (Array.isArray(body)) {
			_this2.body = body.map(function (line, index) {
				return React.createElement(
					"div",
					{ key: index },
					line
				);
			});
		} else if (type === "foreignKey" && props.detail.callback) {
			var foreignProps = {
				callbackForeignKey: function callbackForeignKey(ok, message) {
					_this2.row = message;
					_this2.onConfirm(ok, undefined, props);
				},
				onDoubleClick: function onDoubleClick() {
					return _this2.onConfirm(true, undefined, props);
				},
				keyEvent: props.keyEvent,
				onRowEnter: function onRowEnter(_ref) {
					var row = _ref.row;

					_this2.row = row;
					return true;
				},
				isModal: true,
				status: _this2.state.status,
				refresh: refresh,
				ref: function ref(_ref2) {
					return _this2.zebulonTable = _ref2;
				}
			};

			_this2.body = React.createElement(
				"div",
				null,
				React.cloneElement(body, foreignProps)
			);
		} else if (type === "conflict" && props.detail.callback) {
			var conflictProps = {
				keyEvent: props.keyEvent,
				ref: function ref(_ref3) {
					return _this2.zebulonTable = _ref3;
				}
			};

			_this2.body = React.createElement(
				"div",
				null,
				React.cloneElement(body, conflictProps)
			);
		}
	};

	this.onConfirm = function (carryOn_, ok, props) {
		if (props.show) {
			var carryOn = carryOn_;
			var message = ok;
			if (props.detail.type === "foreignKey") {
				carryOn = carryOn && _this2.row !== undefined;
				message = _this2.row;
			} else if (props.detail.type === "conflict") {
				message = Object.values(_this2.zebulonTable.state.updatedRows).filter(function (row) {
					return row.checked_ && row.index_ !== undefined;
				}).map(function (row) {
					return row.index_;
				}); // a voir
			}
			props.onConfirm();
			if (props.detail.callback) {
				props.detail.callback(carryOn, message);
			}
		}
	};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/ConfirmationModal.js
// module id = 301
// module chunks = 0